export const TEAM_TASK_NOTIFICATIONS_FLAG = "backoffice-team-task-notifications" as const;

export function canShowTaskNotificationPreferences({
  flagOn,
  flagsLoaded,
  accessLoaded = false,
  isGlobalAdmin,
  canManage,
  actorDepartment
}: {
  flagOn: boolean;
  flagsLoaded: boolean;
  accessLoaded?: boolean;
  isGlobalAdmin: boolean;
  canManage: boolean;
  actorDepartment?: string | null;
}): boolean {
  if (!flagsLoaded || !accessLoaded || !flagOn) {
    return false;
  }

  if (isGlobalAdmin) {
    return true;
  }

  return canManage && Boolean(actorDepartment);
}
